export default {
  'title-left': 'Select rules',
  'title-right': 'Additional details (optional)',
  'details-placeholder': 'Additional information for clients ..',
  hint: {
    title: 'Health & Safety rules',
    content: 'The checked items will be visible on your profile for your clients to see. Select only the rules that apply to you and your venue.<br><br>You can also describe additional requirements health-related rules that you’re choosing for implement.',
  },
  modal: {
    title: 'Inform clients about Health & Safety Rules',
    create: 'Create social post',
    'not-now': 'Not now',
  },
}
